import panel from '@/presentation/plugins/presets/components/panel'

export const components = {
  panel: panel
}

export default components
